import { Link, useSearchParams } from 'react-router-dom';
import { AUTH_ERROR_MESSAGES } from '@authsemply/shared';
import { AuthCard } from '../components/AuthCard';
import { Alert } from '../components/Alert';

/** Nom affiché du fournisseur externe passé en `?fournisseur=` par l'API. */
const FOURNISSEURS: Record<string, string> = {
  google: 'Google',
  microsoft: 'Microsoft',
  apple: 'Apple',
};

function messages(fournisseur: string): Record<string, string> {
  return {
    oauth_state_mismatch: `La connexion avec ${fournisseur} a échoué (état invalide). Réessayez.`,
    oauth_failed: `La connexion avec ${fournisseur} a échoué. Réessayez dans un instant.`,
    oauth_unavailable: `La connexion avec ${fournisseur} n'est pas disponible. Utilisez votre adresse e-mail et votre mot de passe.`,
    oauth_email_missing: `Votre compte ${fournisseur} ne nous communique pas d'adresse e-mail. Créez votre compte depuis le formulaire d'inscription.`,
    oauth_email_unverified: `Cette adresse n'est pas vérifiée par ${fournisseur}. Créez votre compte depuis le formulaire d'inscription.`,
    reconnexion_autre_compte: `Ce compte ${fournisseur} n'est pas celui avec lequel vous êtes connecté. Revenez en arrière et confirmez votre identité avec le bon compte.`,
    // Compte lié à un fournisseur mais adresse du compte jamais confirmée (27/09/2026).
    email_not_verified:
      "Votre compte n'est pas encore ouvert : confirmez d'abord votre adresse e-mail avec le lien reçu.",
    oauth_autre_compte_rattache: `Votre compte SEmply est déjà associé à un autre compte ${fournisseur}. Connectez-vous avec celui-ci, ou avec votre adresse e-mail et votre mot de passe.`,
    // Ancien code, encore émis par une API antérieure au 27/09/2026.
    google_email_unverified:
      "Cette adresse n'est pas vérifiée par Google. Créez votre compte depuis le formulaire d'inscription.",
    access_denied: 'Autorisation refusée.',
    login_required: 'Session expirée, reconnectez-vous.',
  };
}

export function ErrorPage() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code') ?? 'not_found';
  // `Object.hasOwn` : les paramètres viennent de l'URL. Un `?code=constructor`
  // ou `?fournisseur=toString` lisait une propriété héritée d'Object — une
  // fonction à la place du texte, et la page cassait (27/09/2026).
  const cleFournisseur = searchParams.get('fournisseur') ?? '';
  const fournisseur = Object.hasOwn(FOURNISSEURS, cleFournisseur) ? FOURNISSEURS[cleFournisseur] : 'ce service';
  const catalogue = messages(fournisseur);
  const message = Object.hasOwn(catalogue, code)
    ? catalogue[code]
    : Object.hasOwn(AUTH_ERROR_MESSAGES, code)
      ? AUTH_ERROR_MESSAGES[code as keyof typeof AUTH_ERROR_MESSAGES]
      : "Cette page n'existe pas ou n'est plus disponible.";

  return (
    <AuthCard title="Oups">
      <Alert message={message} />
      {code === 'email_not_verified' ? (
        <Link className="btn" to="/confirmer-adresse" style={{ marginBottom: '0.5rem' }}>
          Recevoir un nouveau lien
        </Link>
      ) : null}
      <Link className="btn btn-secondary" to="/login">
        Retour à la connexion
      </Link>
    </AuthCard>
  );
}
